import React from "react";
import HOC from "../../components/HOC";
import DetailUser from "../../components/screen/userManagement/DetailUser";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { Breadcrumbs, Link, ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const DetailUserPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Detail Pengguna"
        mainComponent={
          <ThemeProvider theme={theme}>
            <div className="text-[12px]">
              <DetailUser />
            </div>
          </ThemeProvider>
        }
        pageRole={6}
        breadcrumb={
          <Breadcrumbs sx={{ color: "#1761FD", marginBottom: 2, fontSize: 12 }}>
            <Link
              href="/user-management"
              underline="hover"
              color="#1761FD"
              sx={{ color: "#1761FD" }}
            >
              User Management
            </Link>
            <Link
              href="/user-management"
              color="#1761FD"
              sx={{ color: "#1761FD" }}
              underline="none"
            >
              Detail User
            </Link>
          </Breadcrumbs>
        }
      />
    </div>
  );
};

export default HOC(DetailUserPage);
